<template>
  <div class="page-content conmon-top">
    <div
      class="base-input ovf-hd"
      style="margin-bottom: 10px;"
    >
      <el-row class="search-title">
        <el-col
          :span="4"
          class="search-nav-left"
        >
          <i
            class="el-icon-search"
            style="font-weight: bold;"
          ></i>
          <span class="order-list-search-span">筛选查询</span>
        </el-col>
        <el-col
          :span="20"
          class="search-nav-right"
        >
          <el-button
            class="search-open-close"
            type="text"
            @click="hide=!hide"
            v-show="hide"
          >收起查询</el-button>
          <el-button
            class="search-open-close"
            type="text"
            @click="hide=!hide"
            v-show="!hide"
          >展开查询</el-button>
          <i
            v-if="hide === true"
            class="el-icon-arrow-up search-open-close-i"
            @click="hide=!hide"></i>
          <i
            v-if="hide === false"
            class="el-icon-arrow-down search-open-close-i"
            @click="hide=!hide"></i>
          <el-button
            class="search-btn-new"
            type="primary"
            size="small"
            @click="searchLoad"
          >查询</el-button>
        </el-col>
      </el-row>
      <el-collapse-transition>
        <div
          v-show="hide"
          class="search-content common-search-formtype"
        >
          <el-form
            :inline="true"
            :model="formInlineTmp"
            label-width="95px"
            class="search-content-item"
          >
            <el-form-item label="活码名称：">
              <el-input
                @keyup.enter.native="searchLoad"
                v-model.trim="formInlineTmp.name"
                placeholder="请输入活码名称"
                clearable
              ></el-input>
            </el-form-item>
            <el-form-item label="状态：">
              <el-select
                v-model="formInlineTmp.status"
                clearable
                placeholder="请选择"
              >
                <el-option
                  v-for="item in statusOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-form>
        </div>
      </el-collapse-transition>
    </div>
    <el-row
      class="search-title common-table-top"
      style="padding-right:0"
    >
      <el-col
        :span="4"
        style="text-align: left;"
      >
        <i
          class="el-icon-document"
          style="font-weight: bold;"
        ></i>
        <span class="order-list-search-span">数据列表</span>
      </el-col>
      <el-col
        :span="20"
        class="text-align-right"
      >
        <el-button
                v-if="butsObj.add"
          type="primary"
          @click="pushToPage('add')"
          class="add-btn btn-right"
          style="float: right;"
        >新建</el-button>
      </el-col>
    </el-row>
    <el-row class="import-data-title table-first-style">
      <el-table
        :data="tableData"
        v-loading="loading"
        class="table"
      >
        <template slot="empty">
          <div class="newTableEmpty">暂无数据，去<span @click="pushToPage('add')">新建</span></div>
        </template>
        <el-table-column
          prop="name"
          label="活码名称"
        >
          <template slot-scope="scope">
            <div class="op-link" v-if="butsObj.details" @click="pushToPage('detail', scope.row)">
              {{ scope.row.name }}
            </div>
            <div v-else>{{ scope.row.name }}</div>
          </template>
        </el-table-column>
        <el-table-column
          width='70'
          label="二维码"
        >
          <template slot-scope="scope">
            <!-- <qriously :value="scope.row.lottery_url" :size="100" style="margin-left: px;" /> -->
            <img
                    v-if="butsObj.show_qrcode"
              @click="showQRcode(scope.row.url)"
              src="/static/img/erweima.png"
              width="30px"
            >
            <img
                    v-else
                    src="/static/img/erweima.png"
                    width="30px"
            >
          </template>
        </el-table-column>
        <el-table-column
          width='120'
          label="子码数量"
        >
          <template slot-scope="scope">
            {{ scope.row.qrCodeList.length }}
          </template>
        </el-table-column>
        <el-table-column
          width='120'
          label="扫码次数"
        >
          <template slot-scope="scope">
            {{scope.row.totalScanQty}}
          </template>
        </el-table-column>
        <el-table-column
          width='80'
          prop="status"
          label="状态"
        >
          <template slot-scope="scope">
            <span
              v-if="scope.row.status === 0"
            ><span class="pointRed"></span>已禁用</span>
            <span
              v-if="scope.row.status === 1"
            ><span class="pointGreen"></span>已启用</span>
          </template>
        </el-table-column>
        <el-table-column
          width="140"
          label="创建时间"
        >
          <template slot-scope="scope">
            {{ scope.row.createTimeStr }}
          </template>
        </el-table-column>
        <el-table-column
          label="操作"
          width="160"
        >
          <template slot-scope="scope">
            <div class="op-link editColor" v-if="butsObj.edit" @click="pushToPage('edit', scope.row)">
                编辑
            </div>
            <div
              class="op-link"
              v-if="scope.row.status === 1&&butsObj.status_change"
              @click="stopActivityAction(scope.row.id, 0)"
            >
              禁用
            </div>
            <div
                    class="op-link"
                    v-if="scope.row.status === 0&&butsObj.status_change"
                    @click="stopActivityAction(scope.row.id, 1)"
            >
              启用
            </div>
            <div
              class="op-link deleteColor"
              v-if="butsObj.del&&(scope.row.status === 0 || scope.row.status === 3)"
              @click="deleteAction(scope.row.id)"
            >
              删除
            </div>
          </template>
        </el-table-column>
      </el-table>
      <div class="table-foot">
        <el-pagination
          class="table-foot-pagination"
          background
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :page-size="limit"
          layout="total, prev, pager, next, jumper"
          :total="totalCount"
        >
        </el-pagination>
      </div>
      <!--添加二维码分组弹窗-->
      <el-dialog
        class="cellDialog base-dialog"
        title="二维码"
        :visible.sync="qrCodedialog"
        width="620px"
      >
        <el-input
          id="copyObj"
          class="qrcode-show-input"
          type="text"
          v-model.trim="qrCodeUrl"
          auto-complete="off"
          placeholder=""
        ></el-input>
        <el-button
          class="dialog-confirm-btn"
          @click="getUrl"
          style="margin-left: 15px;color: #fff"
        >复制链接</el-button>
        <!--<p style="word-break:break-all;">-->
        <!--{{ qrCodeUrl }}-->
        <!--</p>-->
        <qriously
          :value="qrCodeUrl"
          :size="240"
          v-if="qrCodeUrl!=''"
        />
        <!-- <div slot="footer" class="dialog-footer" style="margin-top: 10px">
                  <el-button class="dialog-cancel-btn" @click="qrCodedialog = false" style="margin-left: 20px">关 闭</el-button>
                </div> -->
      </el-dialog>
    </el-row>
  </div>
</template>
<script>
import { getNimbleCodeList, deleteNimbleCode, getNimbleCodeState } from '@/api/analyse.js'
import { butonsList, getMenId } from '@/api/analyse.js'
export default {
  name: 'activityList',
  data () {
    return {
      loading: true,
      statusOptions: [
        {
          label: '已启用',
          value: '1'
        },
        {
          label: '已禁用',
          value: '0'
        }
      ],
      qrCodedialog: false,
      hide: true,
      tableData: [],
      page: 1,
      totalCount: 0,
      formInlineTmp: {
        name: '',
        status: '',
        page: 1,
        limit: 10,
      }, // 查询参数
      formInline: {
      },
      qrCodeUrl: '',
      limit: 10,
      butsObj: { // button按钮列表
        edit: false,
        status_change: false,
        show_qrcode: false,
        details: false,
        add: false,
        del: false
      }
    }
  },
  methods: {
    // 获取可用菜单按钮列表
    getButtonsList () {
      let params = {
        systemCode: 'ZY_INTELLIQUOR',
        authKey: Lockr.get('authKey'),
        sessionId: Lockr.get('sessionId'),
        menuId: getMenId(this.$route.path)
      }
      butonsList(params).then(res=>{
        if (res.data.code === '200') {
          let result = res.data.result || []
          let arrObj = Object.keys(this.butsObj)
          let newarr  = result.map((item)=>{
            return item.perms
          })
          arrObj.map(it=> {
            if (newarr.indexOf(it)!==-1) {
              this.butsObj[it] = true
            } else {
              this.butsObj[it] = false
            }
          })
        }
      }).catch(err=>{
        this.$message.error(err)
      })
    },
    // 获取二维码地址
    getUrl () {
      let url = document.querySelector('#copyObj')
      url.select() // 选择对象
      document.execCommand('Copy')
    },
    searchLoad () {
      this.page = 1
      this.getData()
    },
    showQRcode (url) {
      this.qrCodedialog = true
      this.qrCodeUrl = url || ''
    },
    pushToPage (type, row) {
      if(type == 'add') {
        router.push({path: '/home/activity-code-add', query: {type: type }})
      } else {
        router.push({path: '/home/activity-code-add', query: {type: type, row: JSON.stringify(row)}})
      }

    },
    stopActivityAction (id, state) {
      getNimbleCodeState({id: id, status: state}).then(res => {
        if (res.data.code == 200) {
          this.getData()
          _g.toastMsg('success', res.data.message)
        } else {
          _g.toastMsg('error', res.data.message)
        }
      })
    },
    // 删除活动
    deleteAction (id) {
      this.$confirm('确认删除该活码?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        deleteNimbleCode(id).then((res) => {
          if (res.data.code == 200) {
            this.getData()
            _g.toastMsg('success', '删除成功')
          } else {
            _g.toastMsg('error', res.data.error)
          }
        })
      }).catch((error) => {
      })
    },
    // 处理分页
    handleSizeChange (val) {
      this.limit = val
    },
    handleCurrentChange (page) {
      this.formInlineTmp.page = page
      this.getData()
    },
    copyAcivityAction (id) {
      copyAcivity(id).then(res => {
        if (res.data.code === 0) {
          _g.toastMsg('success', res.data.error)
          this.getData()
        } else {
          _g.toastMsg('error', res.data.error)
        }
      })
    },
    getData () {
      this.loading = true
      getNimbleCodeList(this.formInlineTmp).then(res => {
        this.tableData = res.data.result.list
        this.totalCount = res.data.result.total
      })
      this.openLoading()
    },
    // 数据加载时的动画
    openLoading () {
      setTimeout(() => {
        this.loading = false
      }, 500)
    }
  },
  created () {
    this.getButtonsList()
    this.getData()
  },
  components: {
  }
}
</script>

<style scoped>
.sign-manage-title {
  height: 40px;
}
.content-one span {
  display: inline-block;
  float: left;
  line-height: 20px;
  font-size: 16px;
  margin-top: 10px;
}
.content-one p {
  text-align: left;
}
</style>
